/** The URL query param key to show the enquiry modal on page load. */
export const ENQUIRE_MODAL_SHOWUP_KEY = 'enquire';
export const ENQUIRE_MODAL_SHOWUP_KEY_VALUE = '1';
export const ENQUIRE_AUTH_SOURCE_VALUE = 'enquiry';

/**
 * sessionStorage key holding the saved enquiry form session (JSON,
 * see `enquiryFormSessionSchema`). Stored in sessionStorage because completing
 * the logged-out enquiry auth flow reloads the document, and the enquiry is
 * re-sent from this saved session afterwards.
 */
export const ENQUIRY_SESSION_STORAGE_KEY = 'enquiry-form-session';

/**
 * sessionStorage key flagging that the saved enquiry session should be
 * auto-submitted once the user is logged in (JSON boolean). Set when a guest's
 * enquiry submit hits the auth wall; cleared when the auto-submit fires or the
 * user cancels the auth prompt.
 */
export const ENQUIRY_AUTO_SUBMIT_STORAGE_KEY = 'enquiry-form-auto-submit';
